export default __webpack_public_path__ + "static/thermiclance-lance-products-95062261734207653cfd7e6e366159be.gif";